import $ from 'jquery';

import MediaHelper from '../helpers/MediaHelper.js';

/**
 * Get the amount of items a carousel should scroll
 *
 * @param elem
 * @returns {number|number}
 */
export function getMoveCount( elem ) {
	const numCountDefault = parseInt( elem.getAttribute( 'data-en-slide-num-default' ) ) || 1;
	const numCountSmall = parseInt( elem.getAttribute( 'data-en-slide-num-small' ) ) || numCountDefault;
	const numCountMedium = parseInt( elem.getAttribute( 'data-en-slide-num-medium' ) ) || numCountSmall;
	const numCountDesktop = parseInt( elem.getAttribute( 'data-en-slide-num-desktop' ) ) || numCountMedium;
	const numCountLarge = parseInt( elem.getAttribute( 'data-en-slide-num-large' ) ) || numCountDesktop;

	switch ( true ) {
		case MediaHelper.matches( 'large' ) :
			return numCountLarge;
		case MediaHelper.matches( 'desktop' ) :
			return numCountDesktop;
		case MediaHelper.matches( 'medium' ) :
			return numCountMedium;
		case MediaHelper.matches( 'small' ) :
			return numCountSmall;
		default:
			return numCountDefault;
	}
}

/**
 * Get the dimension of an element which can be also hidden
 *
 * @param elem
 * @returns {{innerWidth: *, innerHeight: *, outerHeight: number, scrollHeight: *, outerWidth: number, scrollWidth: *}}
 */
export function getHiddenDimensions( elem ) {
	let hidden = [];
	let style;
	let elemRe = elem;

	while( elemRe.parentNode.tagName != 'HTML' ) {
		style = elemRe.currentStyle ? elemRe.currentStyle:getComputedStyle( elemRe,null );
		if( style.display=='none' ) {
			hidden.push( {
				'elemRe': elemRe,
				'position':style.position,
				'visibility':style.visibility,
				'display':style.display
			} );
			elemRe.style.setProperty( 'position', 'absolute', 'important' );
			elemRe.style.setProperty( 'visibility', 'hidden', 'important' );
			elemRe.style.setProperty( 'display', 'block', 'important' );
		}
		elemRe = elemRe.parentNode;
	}

	const results= {
		innerWidth: elem.clientWidth,
		innerHeight: elem.clientHeight,
		outerWidth: elem.offsetWidth,
		outerHeight: elem.offsetHeight,
		scrollWidth: elem.scrollWidth,
		scrollHeight: elem.scrollHeight,
		offsetTop: elem.offsetTop,
		offsetLeft: elem.offsetLeft,
	};

	for ( var i = hidden.length; i > 0; --i ) {
		hidden[i-1].elemRe.removeAttribute( 'style' );
	}
	return results;
}

export function scrollElement( elem, position, orientationVertical = false, cb ) {
	if( cb && ( typeof cb === 'function' ) ) {
		let timer = 0;
		const scrollListener = () => {
			if( timer ) clearTimeout( timer );

			timer = setTimeout( () => {
				elem.removeEventListener( 'scroll', scrollListener );
				cb();
			}, 100 );
		};

		elem.addEventListener( 'scroll', scrollListener );
	}

	elem.scroll( {
		...( orientationVertical && { top: position } ),
		...( !orientationVertical && { left: position } ),
		behavior: 'smooth'
	} );
}

export function toggleSlide( targetEl, toggleState = false ) {
	if ( toggleState ) {
		$( targetEl ).slideDown( 200 );
	} else {
		$( targetEl ).slideUp( 200 );
	}
}

export function toggleDisplay( targetEl, toggleState = false ) {
	if ( toggleState ) {
		$( targetEl ).show();
		//targetEl.style.display = 'block';
	} else {
		$( targetEl ).hide();
		//targetEl.style.display = 'none';
	}
}

export function asyncAnimate( targetEl, animation, options = {} ) {
	const promise = new Promise( ( resolve, reject ) => {
		promise.animation = targetEl.animate( animation, options );
		promise.animation.onfinish = () => resolve();
		promise.animation.oncancel = () => reject();
	} );
}

export const observeStyle = (
	target,
	property,
	callback,
	initialValue = ''
) => {
	let frameId, value

	const css = getComputedStyle( target )

	const observer = () => {
		frameId = requestAnimationFrame( observer )
		value = css.getPropertyValue( property ).trim()

		if ( value !== initialValue ) {
			callback( initialValue = value )
		}
	}

	observer()
	return () => cancelAnimationFrame( frameId );
}


/**
 * https://www.geodatasource.com/developers/javascript
 * lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)
 * lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)
 * unit = the unit you desire for results
 *      where: 'M' is statute miles (default)
 *             'K' is kilometers
 *             'N' is nautical miles
 */
export function latlngdistance( lat1, lon1, lat2, lon2, unit ) {
	if ( ( lat1 == lat2 ) && ( lon1 == lon2 ) ) {
		return 0;
	} else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin( radlat1 ) * Math.sin( radlat2 ) + Math.cos( radlat1 ) * Math.cos( radlat2 ) * Math.cos( radtheta );
		if ( dist > 1 ) {
			dist = 1;
		}
		dist = Math.acos( dist );
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		if ( unit=="K" ) { dist = dist * 1.609344 }
		if ( unit=="N" ) { dist = dist * 0.8684 }
		return dist;
	}
}

export function isDefined( value, path ) {
	var parts = path.split( '.' );
	for ( var i = 0; i < parts.length; i++ ) {
		var key = parts[i];
		value = value && value[key];
	}
	return ( typeof value !== 'undefined' && value !== null );
}

export function format_price( price, locale ) {
	const currencyCountry = locale || getCurrencyCode();

	const usedLocale = currencyCountry === 'de-CH' || currencyCountry === 'fr-FR'
		? currencyCountry
		: 'de-DE';

	return Number( price ).toLocaleString( usedLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 } );
}

export function parse_price( price, locale ) {
	const usedLocale = locale || getCurrencyCode();

	const localeFormats = {
		'de-DE': { thousands: /\./g, decimal: ',' }, // 1.234,56
		'de-CH': { thousands: /[’']/g, decimal: '.' }, // 1’234.56 or 1'234.56
		'fr-FR': { thousands: /[\s\u00A0\u202F]/g, decimal: ',' }, // 1 234,56
	};

	const format = ( usedLocale === 'de-CH' || usedLocale === 'fr-FR' ) && localeFormats[usedLocale]
		? localeFormats[usedLocale]
		: localeFormats['de-DE'];

	const normalized = price.toString().replace( format.thousands, '' ).replace( format.decimal, '.' );

	return parseFloat( normalized );
}

export function format_number( numberToParse, localeParam, optionsParam ) {
	var locale = localeParam || null;
	var options = optionsParam || {};

	if ( ! locale ) {
		locale = document.documentElement.lang;
	}

	// Use de-DE instead, because their number formats nicer.
	if ( 'de-AT' === locale ) {
		locale = 'de-DE'
	}

	return parseFloat( numberToParse ).toLocaleString( locale, options )
}

export function setLoading( state ) {
	document.documentElement.classList.toggle( 'en_is_loading', !! state );
}

export function safeStringSplit( value, separator = '|' ) {
	if ( typeof value === 'string' ) {
		return value.split( separator );
	}
	return [];
}

export function isTrueString( value ) {
	return String( value ).toLowerCase() === 'true';
}

export function isFalseString( value ) {
	return String( value ).toLowerCase() === 'false';
}

export function arrayUnique( inputArray ) {
	return inputArray.filter( ( item, index ) => inputArray.indexOf( item ) === index );
}

export function make_link_relative( href, base = window.location.href ) {
	const urlBuilder = new URL( href, base );
	return urlBuilder.pathname + urlBuilder.search;
}

export function isMobileApp() {
	return navigator.userAgent && navigator.userAgent.startsWith( 'koe-pluscard-app' );
}

export function getMetaContent( metaname = "" ) {
	return document.querySelector( 'meta[name="' + metaname + '"]' )?.content || '';
}

export function getCurrencyCode( defaultLocale = 'de-DE' ) {
	return getMetaContent( '_currency_country_code' ) || defaultLocale;
}

export function getSelectedFilter( fieldset, identifier ) {
	const content = fieldset.querySelector( '.mdl_filter__item-content' );
	let result = {};
	let elements = content.querySelectorAll( 'input[type="checkbox"]' );

	switch( identifier ) {
		case 'newarriveds':
			elements = content.querySelectorAll( 'input[type="radio"][name="newarrived"], input[type="checkbox"][name="new"]' );
			break;
		case 'prices':
			elements = content.querySelectorAll( 'input[type="hidden"][name="price[from]"], input[type="hidden"][name="price[to]"], input[type="checkbox"][name="sale"]' );
			break;
	}

	elements.forEach( el => {
		if ( !el.name || el.disabled ) return;

		const name = el.name;
		const isCheckboxOrRadio = ( el.type === 'checkbox' || el.type === 'radio' );

		// Unchecked checkbox/radio? Skip
		if ( isCheckboxOrRadio && !el.checked ) return;

		let value;

		if ( el.tagName === 'SELECT' && el.multiple ) {
			value = Array.from( el.selectedOptions ).map( opt => opt.value );
		} else {
			value = el.value;
		}

		const isArrayField = name.endsWith( '[]' );
		const cleanName = isArrayField ? name.slice( 0, -2 ) : name;

		if ( isArrayField || Object.prototype.hasOwnProperty.call( result, cleanName ) ) {
			if ( !Array.isArray( result[cleanName] ) ) {
				result[cleanName] = result[cleanName] !== undefined ? [result[cleanName]] : [];
			}

			if ( Array.isArray( value ) ) {
				result[cleanName].push( ...value );
			} else {
				result[cleanName].push( value );
			}
		} else {
			result[cleanName] = value;
		}
	} );

	// Alter result for prices filter
	if( identifier === 'prices' && 'price[from]' in result && 'price[to]' in result ) {
		const {
			'price[from]': priceFrom,
			'price[to]': priceTo,
			...rest
		} = result;

		result = {
			...rest,
			pricefromto: {
				from: priceFrom,
				to: priceTo
			}
		};
	}

	return result;
}

export function getShopToDyFilterMapping() {
	return {
		'brand': 'brand',
		'theme': 'gender',
		'size': 'size',
		'new': 'new',
		'newarrived': 'NewArrived',
		'color': 'color',
		'sale': 'sale',
		'saison': 'saison',
		'pseries': 'produktserie',
	}
}

export function appVersionCompare( compareableVersion ) {
	const match = navigator.userAgent.match( /koe-pluscard-app (\d+\.\d+\.\d+)/ );
	const currentVersion = match ? match[1] : '0.0.0';

	const a = currentVersion.split( '.' ).map( Number );
	const b = compareableVersion.split( '.' ).map( Number );
	const len = Math.max( a.length, b.length );

	for ( let i = 0; i < len; i++ ) {
		const x = a[i] || 0;
		const y = b[i] || 0;

		if ( x > y ) return true;
		if ( x < y ) return false;
	}
	return true;
}
